import {useGetWineShopListQuery} from 'modules/wineshops-list/services';
import {useMemo} from 'react';

const WINE_SHOPS_STOCK_TYPES_CODES = {
    BAR: 'bar',
    CELLAR: 'cellar',
};

const {BAR, CELLAR} = WINE_SHOPS_STOCK_TYPES_CODES;

export const useWineshopList = () => {
    const wineshopsResponseData = useGetWineShopListQuery();

    return useMemo(() => {
        const data = wineshopsResponseData?.data?.data;

        if (!data) {
            return [];
        }

        return data.items.filter(({stockTypes}) => {
            return stockTypes.some(({code}) => {
                return BAR === code || CELLAR === code;
            });
        });
    }, [wineshopsResponseData]);
};
